








































import { Component, Vue, Watch } from 'vue-property-decorator';

// Components
import BlInfo from '@/components/shipment/detail/BlInfo.vue';
import ContainerInfo from '@/components/shipment/detail/ContainerInfo.vue';
import CustomsInfo from '@/components/shipment/detail/CustomsInfo.vue';
import PartyDetailsInfo from '@/components/shipment/detail/PartyDetailsInfo.vue';
import PaymentInfo from '@/components/shipment/detail/PaymentInfo.vue';

// GQL
import {
  ShipmentUpdateInput,
  fetchShipmentDetails_shipments
} from '@/types/graphql/schemaTypes';
import FetchShipmentDetails from '@/graphql/queries/shipment/FetchShipmentDetails.gql';

@Component({
  components: {
    BlInfo,
    ContainerInfo,
    CustomsInfo,
    PartyDetailsInfo,
    PaymentInfo
  },
  apollo: {
    shipment: {
      query: FetchShipmentDetails,
      prefetch: true,
      variables() {
        return {
          shipmentArgs: {
            shipmentId: this.$route.params.id
          }
        };
      },
      update: data => data && data.shipments && data.shipments[0],
      fetchPolicy: 'cache-and-network'
    }
  }
})

export default class ShipmentDetails extends Vue {
  public shipment: fetchShipmentDetails_shipments | null = null;

  @Watch('$store.state.Shipment.action')
  refreshShipment(action: string) {
    if (action === 'refresh') {
      this.$apollo.queries.shipment.refetch();
      this.$store.dispatch('Shipment/setAction', '');
    }
  }
}
